export default __webpack_public_path__ + "static/media/user_img.f205dd1c.png";